import { createAction } from '@reduxjs/toolkit';

const clearInvoiceView = createAction('clearInvoiceView');

export default clearInvoiceView;
